import {
  SocketCommand,
  socketManager,
} from "../../../../components/AppProvider";

export const socketEtcView = (type, params) => {
  socketManager(SocketCommand.ETC_VIEW_OPEN, callbackHandle, {
    procType: type,
    seqNo: params.seqNo,
    dataType: params.dataType,
    dataDt: params.dataDt,
    dataTitle: params.dataTitle,
    fileNm: params.fileNm,// ["ED_20230126153139272.jpg"],
  });
};

const callbackHandle = () => {
  alert("성공");
};
